import { Routes, Route } from 'react-router-dom'
import { isDevEnvironment } from './config'
import Layout from './components/common/Layout'
import EventList from './pages/EventList'
import Registration from './pages/Registration'
import WaitlistPayment from './pages/WaitlistPayment'
import Success from './pages/Success'
import Cancel from './pages/Cancel'
import SponsorForm from './pages/SponsorForm'
import SponsorSuccess from './pages/SponsorSuccess'
import SponsorLogoUpload from './pages/SponsorLogoUpload'
import AmbassadorForm from './pages/AmbassadorForm'
import AmbassadorSuccess from './pages/AmbassadorSuccess'
import AdminLayout from './components/admin/AdminLayout'
import AdminDashboard from './pages/admin/Dashboard'
import AdminRegistrations from './pages/admin/Registrations'
import AdminTeams from './pages/admin/Teams'
import AdminSponsors from './pages/admin/Sponsors'
import AdminAmbassadors from './pages/admin/Ambassadors'
import AdminMarketing from './pages/admin/Marketing'
import AdminCoupons from './pages/admin/Coupons'
import AdminLogin from './pages/admin/Login'

function App() {
  return (
    <>
      {isDevEnvironment() && (
        <div className="bg-yellow-500 text-black text-center py-2 text-sm font-medium">
          TEST MODE - No real charges will be made
        </div>
      )}
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Layout />}>
          <Route index element={<EventList />} />
          <Route path="e/:slug" element={<Registration />} />
          <Route path="waitlist-payment/:token" element={<WaitlistPayment />} />
          <Route path="success" element={<Success />} />
          <Route path="cancel" element={<Cancel />} />
          {/* Sponsorship routes */}
          <Route path="s/:slug" element={<SponsorForm />} />
          <Route path="s/:slug/success" element={<SponsorSuccess />} />
          <Route path="sponsor/upload-logo/:submissionId" element={<SponsorLogoUpload />} />
          {/* Ambassador routes */}
          <Route path="ambassador" element={<AmbassadorForm />} />
          <Route path="ambassador/success" element={<AmbassadorSuccess />} />
        </Route>

        {/* Admin routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="registrations" element={<AdminRegistrations />} />
          <Route path="teams" element={<AdminTeams />} />
          <Route path="sponsors" element={<AdminSponsors />} />
          <Route path="ambassadors" element={<AdminAmbassadors />} />
          <Route path="marketing" element={<AdminMarketing />} />
          <Route path="coupons" element={<AdminCoupons />} />
        </Route>
      </Routes>
    </>
  )
}

export default App
